import getDistributionFunctionsByType from 'calculators/distributions';
import { setCutoffs } from 'store/scenes/distributions/cutoffs/actions';
import { getTailType } from 'store/scenes/distributions/chart/selectors';
import { CHART_TAIL_TYPES } from 'store/scenes/distributions/chart/enums';
import { setLeftCutoff, setRightCutoff, setLeftZScore, setRightZScore } from 'store/form/distributions/actions';

import {
  getDistributionsType,
  getDistributionsFormValues
} from 'store/form/distributions/selectors';

export const recalculateCutoffs = newAlpha => (dispatch, getState) => {
  const state = getState();
  const tailType = getTailType(state);
  const type = getDistributionsType(state);
  const fns = getDistributionFunctionsByType(type);
  const distributionFormValues = getDistributionsFormValues(state);
  const isNormalDistribution = type === 'normal';

  // reverse alpha value if tail is center
  const preliminaryAlpha =
  tailType === CHART_TAIL_TYPES.CENTER
    ? 1 - newAlpha
    : newAlpha;

  const alpha =
  tailType === CHART_TAIL_TYPES.BOTH || tailType === CHART_TAIL_TYPES.CENTER
    ? preliminaryAlpha / 2
    : preliminaryAlpha;

  const cutoffs = fns.getCutoffsByAlpha(distributionFormValues, alpha);

  let zScoreLeft = -1;
  let zScoreRight = 1;
  // z score is available only for the normal distribution
  if (isNormalDistribution) {
    zScoreLeft = fns.getZScoreByCutoffValue(distributionFormValues, cutoffs.left.x);
    zScoreRight = fns.getZScoreByCutoffValue(distributionFormValues, cutoffs.right.x);
  }

  dispatch([
    setCutoffs(cutoffs),

    setLeftCutoff(cutoffs.left.x),
    setRightCutoff(cutoffs.right.x),

    setLeftZScore(zScoreLeft),
    setRightZScore(zScoreRight)
  ]);
};
